// @ts-nocheck
import { Injectable } from '@angular/core';

@Injectable({
	providedIn: 'root',
})
export class DateEditService {
	private date: any = '';

	constructor() {}

	set setDate(value: any) {
		this.date = value;
	}
	get getDate() {
		return this.date;
	}
}
